/**
 * Goods receipts list — the procure-to-pay receiving inbox.
 *
 * @see prototype/purchases/goods-receipts.html — V1.1 baseline (list)
 */
import { createFileRoute, notFound } from "@tanstack/react-router";
import { hasPermission } from "@flint/api-contract";
import { WorkspaceShell } from "../../../../features/workspace/index.ts";
import { GrnListPage } from "../../../../features/goods-receipts/index.ts";
import { meQueryOptions } from "../../../../lib/session.ts";

export const Route = createFileRoute("/(workspace)/procurement/goods-receipts/")({
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.ensureQueryData(meQueryOptions).catch(() => null);
    const perms = me?.company?.permissions ?? [];
    if (!hasPermission(perms, "goodsReceipts.view")) {
      throw notFound();
    }
  },
  component: GoodsReceiptsListRoute,
});

function GoodsReceiptsListRoute() {
  return (
    <WorkspaceShell
      breadcrumbs={[{ label: "Procurement", to: "/" }, { label: "Goods receipts" }]}
    >
      <GrnListPage />
    </WorkspaceShell>
  );
}
